import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';
import type { FetchQueryOptions, QueryKey as RQQueryKey } from '@tanstack/react-query';

export type SafeQueryOptions<QueryFnData, Error, Data, QueryKey extends RQQueryKey> = Omit<
  FetchQueryOptions<QueryFnData, Error, Data, QueryKey>,
  'queryKey' | 'queryFn' | 'queryKeyHashFn'
>;

// @deprecated use query options instead — see README.md
export function createQueryFetcher<
  Dependencies,
  QueryFnData = unknown,
  Error = unknown,
  Data = QueryFnData,
  QueryKey extends RQQueryKey = RQQueryKey,
>(queryFactory: (deps: Dependencies) => FetchQueryOptions<QueryFnData, Error, Data, QueryKey>) {
  return async (deps: Dependencies, options?: SafeQueryOptions<QueryFnData, Error, Data, QueryKey>) => {
    return getQueryClient().fetchQuery({ ...options, ...queryFactory(deps) });
  };
}
